<template>
  <div class="content">
    <div class="content-top">
      <div @click="toCountList(1)">
        <img style="width:64px;height: 64px" src="../../../assets/image/newAnKang/add.png">
        <div>
          <p class="number">{{count.registered || 0}}</p>
          <p class="person">注册人数</p>
        </div>
      </div>
      <div @click="toCountList(2)">
         <img style="width:64px;height: 64px" src="../../../assets/image/newAnKang/verification.png">
          <div>
            <p class="number">{{count.unregistered || 0}}</p>
            <p class="person">核验人数</p>
          </div>
      </div>
      <div @click="toCountList(6)">
         <img style="width:64px;height: 64px" src="../../../assets/image/newAnKang/no.png">
          <div>
            <p class="number">{{count.gray || 0}}</p>
            <p class="person">灰码人数</p>
          </div>
      </div>
      <div @click="toCountList(3)">
         <img style="width:64px;height: 64px" src="../../../assets/image/newAnKang/green.png">
        <div>
          <p class="number">{{count.green || 0}}</p>
          <p class="person">绿码人数</p>
        </div>
      </div>
      <div @click="toCountList(4)">
         <img style="width:64px;height: 64px" src="../../../assets/image/newAnKang/yellow.png">
          <div>
            <p class="number">{{count.yellow || 0}}</p>
            <p class="person">黄码人数</p>
          </div>
      </div>
      <div @click="toCountList(5)">
         <img style="width:64px;height: 64px" src="../../../assets/image/newAnKang/red.png">
          <div>
            <p class="number">{{count.red || 0}}</p>
            <p class="person">红码人数</p>
          </div>
      </div>
    </div>
    <div class="content-bottom">
      <div class="title">近七天健康码数据统计</div>
      <div id="chart" style="height: 64vh;width: 88vw;"></div>
    </div>
  </div>
</template>

<script>
  import base from '../../../untils/base'
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  export default {
    data() {
      return {
        count: {},
        projectId: util.session.get('groupId'),
        date: [],
        greenData: [],
        yellowData: [],
        redData: [],
        grayData: []
      }
    },
    created() {
      this.getCount()
      this.getData()
    },
    methods: {
      //获取数据
      getCount(){
        myHttp.dayStatisticalAnKang({
            projectId:this.projectId
        }).then(resp =>{
          if(resp.data.code=='200'){
            this.count = resp.data.data
          }
        })
      },

      //  获取图表数据
      getData(){
        myHttp.recentWeekStatistical({
          projectId: this.projectId
        }).then(resp => {
          console.log(resp);
          if(resp.data.code === 200){
            const data = resp.data.data
           if(data.green){
             data.green.forEach(item => {
              this.date.push(item.day)
              this.greenData.push(item.count)
            })
           }
           if(data.yellow){
            data.yellow.forEach(item => {
              this.yellowData.push(item.count)
            })
           }
           if(data.red){
              data.red.forEach(item => {
              this.redData.push(item.count)
            })
           }
           if(data.gray){
            data.gray.forEach(item => {
              this.grayData.push(item.count)
            })
           }
           console.log(this.redData);
           console.log(this.grayData);
            this.initChart()
          }
        })
      },

      // 去统计列表
      toCountList(flag){
        this.$router.push({
          path: '/newAnkangData',
          query: {
            flag: flag
          }
        })
      },

      initChart(){
        let chart = this.$echarts.init(document.querySelector('#chart'))
        chart.setOption({
          grid: {
            left: '10%',
            right: '5%'
          },
          xAxis: {
            boundaryGap: false,
            data: this.date,
          },
          yAxis: {},
          tooltip: {
            trigger: 'axis'
          },
          color: ['#50C8BB', '#E4CE47', '#E37F6C', '#979A9F'],
          series: [
            {
              name: '绿码',
              type: 'line',
              smooth: true,
              data: this.greenData,
              // areaStyle: {
              //   opacity: 0.8,
              //   color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              //     {
              //       offset: 0,
              //       color: 'rgb(128, 255, 165)'
              //     },
              //     {
              //       offset: 1,
              //       color: 'rgb(1, 191, 236)'
              //     }
              //   ])
              // },
            },
            {
              name: '黄码',
              type: 'line',
              smooth: true,
              data: this.yellowData
            },
            {
              name: '红码',
              type: 'line',
              smooth: true,
              data: this.redData
            },
            {
              name: '灰码',
              type: 'line',
              smooth: true,
              data: this.grayData
            } 
          ]
        })
      }
    },
  }
</script>

<style scoped>
.content-top{
  display: flex;
  justify-content: space-between;
}
.content-top > div {
  position: relative;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 150px;
  width: 15%;
  border-radius: 6px;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  padding-right: 1vw;
  cursor: pointer;
}
.content-bottom{
  border-radius: 6px;
  background: #FFFFFF;
  margin-top: 2vh;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.title{
  font-size: 18px;
  padding: 2vh 1vw;
  border-bottom: 2px solid #E7E7E7;
  text-align: left;
}
.content-top > div:nth-child(1){
  background: url('../../../assets/image/new/bg1.png') 63% 41%;
  box-shadow: 2px 2px 6px 0px rgba(108, 140, 239, 0.6);
}
.content-top > div:nth-child(2){
  background: url('../../../assets/image/new/bg2.png') 63% 41%;
  box-shadow: 2px 2px 6px 0px rgba(59, 164, 231, 0.6);
}
.content-top > div:nth-child(3){
  background: url('../../../assets/image/new/bg3.png') 63% 41%;
  box-shadow: 2px 2px 6px 0px rgba(135, 136, 138, 0.6);
}
.content-top > div:nth-child(4){
  background: url('../../../assets/image/new/bg4.png') 63% 41%;
  box-shadow: 2px 2px 6px 0px rgba(35, 204, 161, 0.6);
}
.content-top > div:nth-child(5){
  background: url('../../../assets/image/new/bg5.png') 63% 41%;
  box-shadow: 2px 2px 6px 0px rgba(237, 132, 7, 0.6);
}
.content-top > div:nth-child(6){
  background: url('../../../assets/image/new/bg6.png') 63% 41%;
  box-shadow: 2px 2px 6px 0px rgba(249, 105, 59, 0.6);
}
.number{
  font-size: 40px;
  color: #fff;
}
.person{
  font-size: 20px;
  color: #fff;
}
</style>